import DriveService from "../../../../../services/drive-service";
import FootballState from "../../../state/football-state";
import Rule from "../../../../common/rule";

export default class AddToDrive extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        // Penalty-only plays terminate on NoPenaltyEndOfPlay rather than the
        // standard EndOfPlay. They still belong to a drive (an accepted penalty
        // is part of the drive in progress / the new drive it sets up), so they
        // must be assigned a driveId like any other play.
        return (
            fragment.associatedState === FootballState.EndOfPlay ||
            fragment.associatedState === FootballState.NoPenaltyEndOfPlay
        );
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        play.driveId = await DriveService.resolveDriveId(play, gameContext);
    }
}
